// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__KLA-U","rightAdornment":"Header_rightAdornment__2m7bI"};